import { render, staticRenderFns } from "./ConciergeEvents.vue?vue&type=template&id=41a0ecf8&scoped=true"
import script from "./ConciergeEvents.ts?vue&type=script&lang=ts&external"
export * from "./ConciergeEvents.ts?vue&type=script&lang=ts&external"
import style0 from "./ConciergeEvents.vue?vue&type=style&index=0&id=41a0ecf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a0ecf8",
  null
  
)

export default component.exports